<template>
  <div class="whatsapp-btn"
    :style="customStyle">

    <v-btn
      :href="whatsappUrl" target="_blank"
      color="rgba(37,211,102,1)"
      fab
      x-large
      dark
    >
      <v-icon >mdi-whatsapp</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'WhatsappBtn',
  props: {
    whatsappNumber: {
      type: String,
      // default: '85295158571'
      default: ''
    },
    transitionName: {
      type: String,
      default: 'fade'
    },
    customStyle: {
      type: Object,
      default () {
        return { bottom: '200px', right: '100px' }
      }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    whatsappUrl () {
      return `https://api.whatsapp.com/send/?phone=${this.whatsappNumber}`
    }
  }
}
</script>

<style lang="scss" scoped>
.whatsapp-btn{
  position: fixed;
  cursor: pointer;
  text-align: center;
  transition: .3s;
  /* box-shadow: 0 0 6px rgba(0,0,0,.12); */
  z-index: 99;
  /* i{
    color: #409eff;
    display: block;
    line-height: inherit;
    text-align: center;
    font-size: 18px;
  } */
}
</style>
